const React = require('react')

class BannerComponent extends React.Component {

    componentDidMount() {
        this.showBanner()
    }

    componentWillUnmount() {
        this.destroyBanner()
    }

    showBanner() {
        const Banner = require('./banner')
        this.banner = new Banner(this.props)
    }

    destroyBanner() {
        if (this.banner) this.banner.destroy()
    }

    render() {
        return <div />
    }

}

module.exports = BannerComponent
